import React, { useEffect, useState, useContext } from 'react';
import isEmpty from 'lodash/isEmpty';

import { AuthContext } from '../../../context/authContext';
import { FarmContext } from '../../../context/farmContext';

import Button from '../../helpers/Button';

import { useSessionState } from '../../../utils/useStorageHooks';
import { formatDollar } from '../../../utils/CurrencyFormatter';

const NextEvent = ({ menuOpen, activityId, activities, tasksLength, crop, acreage }) => {
  const { session, setSession } = useContext(AuthContext);
  const { fetchTask } = useContext(FarmContext);

  const [nextEvent, setNextEvent] = useSessionState('nextEvent', true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!nextEvent) {
      if (session) {
        let activity = activities.filter(activity => activity._id === activityId)[0];
        let taskId = activity.tasks[tasksLength];
        if (taskId) {
          (async () => {
            try {
              let task = await fetchTask(taskId);
              if (task.code === 200) {
                setNextEvent(task.data, true);
              } else setError('Unexpected Server Error!');
            } catch (error) {
              if (error && error.status === 401) setSession(false);
              else setError('Unexpected Network Error!');
            }
          })();
        } else setNextEvent({}, true);
      }
    }
  }, [
    activities,
    activityId,
    fetchTask,
    nextEvent,
    session,
    setNextEvent,
    setSession,
    tasksLength
  ]);

  return (
    <div className={`flex justify-center px-4 md:px-0 mx-auto mb-10 ${menuOpen ? 'md:pl-24' : ''}`}>
      <div className="flex w-full md:w-4/5 lg:w-133">
        <span className="hidden md:block">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="30" height="30">
            <path d="M368.005 272h-96v96h96v-96zm-32-208v32h-160V64h-48v32h-24.01c-22.002 0-40 17.998-40 40v272c0 22.002 17.998 40 40 40h304.01c22.002 0 40-17.998 40-40V136c0-22.002-17.998-40-40-40h-24V64h-48zm72 344h-304.01V196h304.01v212z" />
          </svg>
        </span>
        <div className="bg-white rounded px-6 py-4 md:ml-2 lg:ml-6">
          <div className="flex items-center">
            <div className="hidden md:block h-16 w-20 overflow-hidden rounded-full border-2 border-gray-600 xl:border-gray-300 my-3">
              <img
                src={crop.imageUrl}
                alt={crop.name}
                className="inline-block h-full w-full object-cover"
              />
            </div>
            <div className="ml-6">
              <h5 className="border-b-2 border-green-600 text-sm md:text-base overflow-hidden">
                Scheduled Events: {!isEmpty(nextEvent) ? nextEvent.title : 'None'}
              </h5>
              {error ? (
                <p className="text-xs text-red-500">{error}</p>
              ) : (
                <>
                  {!isEmpty(nextEvent) && (
                    <div className="mt-1">
                      <Button
                        name={'Input - ' + nextEvent.input}
                        className="text-sm md:text-base mr-1 mb-1 border-2 border-cf-300 text-cf-300 rounded p-1 focus:outline-none"
                      />
                      <Button
                        name={'Tool - ' + nextEvent.tool}
                        className="text-sm md:text-base mr-1 mb-1 border-2 border-cf-300 text-cf-300 rounded p-1 focus:outline-none"
                      />
                      <Button
                        name={'Labour - ' + nextEvent.labour}
                        className="text-sm md:text-base mr-1 mb-1 border-2 border-cf-300 text-cf-300 rounded p-1 focus:outline-none"
                      />
                      <Button
                        name={'Cost - ' + formatDollar(nextEvent.cost * acreage)}
                        className="text-sm md:text-base mr-1 mb-1 border-2 border-cf-300 text-cf-300 rounded p-1 focus:outline-none"
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextEvent;
